import _classCallCheck from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/inherits";
import { formatOffset as _formatOffset, parseZoneInfo, hasIntl } from "../impl/util.js";
import Zone from "../zone.js";
var singleton = null;
/**
 * Represents the local zone for this Javascript environment.
 * @implements {Zone}
 */

var LocalZone =
/*#__PURE__*/
function (_Zone) {
  _inherits(LocalZone, _Zone);

  function LocalZone() {
    _classCallCheck(this, LocalZone);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocalZone).apply(this, arguments));
  }

  _createClass(LocalZone, [{
    key: "offsetName",

    /** @override **/
    value: function offsetName(ts, _ref) {
      var format = _ref.format,
          locale = _ref.locale;
      return parseZoneInfo(ts, format, locale);
    }
    /** @override **/

  }, {
    key: "formatOffset",
    value: function formatOffset(ts, format) {
      return _formatOffset(this.offset(ts), format);
    }
    /** @override **/

  }, {
    key: "offset",
    value: function offset(ts) {
      return -new Date(ts).getTimezoneOffset();
    }
    /** @override **/

  }, {
    key: "equals",
    value: function equals(otherZone) {
      return otherZone.type === "local";
    }
    /** @override **/

  }, {
    key: "type",

    /** @override **/
    get: function get() {
      return "local";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      if (hasIntl()) {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
      } else return "local";
    }
    /** @override **/

  }, {
    key: "universal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }], [{
    key: "instance",

    /**
     * Get a singleton instance of the local zone
     * @return {LocalZone}
     */
    get: function get() {
      if (singleton === null) {
        singleton = new LocalZone();
      }

      return singleton;
    }
  }]);

  return LocalZone;
}(Zone);

export { LocalZone as default };